'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _actions = require('../../../../store/blueprint/actions');

var _selectors = require('../../../../store/blueprint/selectors');

var _generic = require('../../../../helpers/generic');

require('./ProgressUploadFile.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressUploadFile = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    session: state.session,
    record: ownProps.record
  };
}, function (dispatch) {
  return {
    updateExportJobEntry: (0, _redux.bindActionCreators)(_actions.putExportList, dispatch)
  };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ProgressUploadFile, _Component);

  function ProgressUploadFile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ProgressUploadFile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ProgressUploadFile.__proto__ || (0, _getPrototypeOf2.default)(ProgressUploadFile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      fileList: []

      // NOTE: until we update to react 16+, we need to have this in place.
      // React 16+ provides getderivedstatefromprops (https://reactjs.org/docs/react-component.html#static-getderivedstatefromprops)
      // which allows us to update state from props. Currently we have to do it in componentDidMount
      // which causes an extra render.
      /* eslint-disable react/no-did-mount-set-state */
    }, _this.handleChange = function (_ref2) {
      var fileList = _ref2.fileList;

      _this.setState({
        fileList: fileList
      }, function () {
        if (_this.props.updateExportJobEntry) {
          if (fileList.length === 0) {
            _this.props.updateExportJobEntry(_this.props.record, { updateBackend: true });
          } else if (fileList[0].response && fileList[0].response.code === 200) {
            _this.props.updateExportJobEntry(fileList[0].response.data, { updateBackend: false });
          }
        }
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ProgressUploadFile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var record = this.props.record;

      if (record.assetLink) {
        this.setState({
          fileList: [{
            uid: (0, _generic.uuidv4)(),
            name: (0, _generic.getImageNameFromURL)(record.assetLink),
            status: 'done',
            url: record.assetLink
          }]
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          session = _props.session,
          record = _props.record;

      var disableUploadButton = this.state.fileList.length >= 1;

      return _react2.default.createElement(
        'div',
        { className: 'ProgressUploadFile__Component' },
        _react2.default.createElement(
          _antd.Upload,
          {
            accept: 'application/zip',
            name: 'mediaFiles',
            action: (0, _selectors.buildExportJobActionURL)({ session: session, record: record }),
            fileList: this.state.fileList,
            onChange: this.handleChange,
            multiple: false,
            customRequest: function customRequest(option) {
              return (0, _generic.upload)(option, session.wsse);
            }
          },
          !disableUploadButton && _react2.default.createElement(
            _antd.Button,
            { type: 'dashed', className: 'add-media-button' },
            _react2.default.createElement(_antd.Icon, { type: 'upload' }),
            ' Upload Asset'
          )
        )
      );
    }
  }]);
  return ProgressUploadFile;
}(_react.Component), _class2.propTypes = {
  record: _propTypes2.default.shape({
    assetLink: _propTypes2.default.string,
    id: _propTypes2.default.number.isRequired
  }).isRequired,
  session: _propTypes2.default.shape({
    wsse: _propTypes2.default.string.isRequired
  }).isRequired,
  updateExportJobEntry: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = ProgressUploadFile;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/modules/Progress/components/ProgressUploadFile/index.js
// module id = 3943
// module chunks = 7